import { v4 as uuidv4 } from 'uuid';

class CollectionService {
  private static instance: CollectionService;
  private collectionId: string | null = null;
  private collectionName: string | null = null;
  private collectionFolderId: string | null = null;

  private constructor() {}

  public static getInstance(): CollectionService {
    if (!CollectionService.instance) {
      CollectionService.instance = new CollectionService();
    }
    return CollectionService.instance;
  }

  public getCollectionId(): string {
    if (!this.collectionId) {
      // Versuche aus sessionStorage zu laden
      const stored = sessionStorage.getItem('app-collection-id');
      if (stored) {
        this.collectionId = stored;
      } else {
        // Neue Collection generieren
        this.collectionId = uuidv4();
        sessionStorage.setItem('app-collection-id', this.collectionId);
      }
    }
    return this.collectionId;
  }

  public getCollectionName(): string | null {
    if (this.collectionName === null) {
      const stored = sessionStorage.getItem('app-collection-name');
      if (stored) this.collectionName = stored;
    }
    return this.collectionName;
  }

  public setCollectionName(name: string): void {
    this.collectionName = name;
    sessionStorage.setItem('app-collection-name', name);
  }

  public getCollectionFolderId(): string | null {
    if (this.collectionFolderId === null) {
      const stored = sessionStorage.getItem('app-collection-folder-id');
      if (stored) this.collectionFolderId = stored;
    }
    return this.collectionFolderId;
  }

  public setCollectionFolderId(folderId: string): void {
    this.collectionFolderId = folderId;
    sessionStorage.setItem('app-collection-folder-id', folderId);
  }

  public generateFileId(): string {
    return uuidv4();
  }

  public async getSessionId(): Promise<string> {
    try {
      // Import GoogleDriveService dynamisch um Zirkularimport zu vermeiden
      const GoogleDriveService = (await import('./GoogleDriveService')).default;
      const driveService = GoogleDriveService.getInstance();
      
      if (driveService.isSignedIn()) {
        const formattedUsername = await driveService.getFormattedUsername();
        return formattedUsername; // Nur "Vorname-Nachname"
      }
    } catch (error) {
      console.warn('Fehler beim Abrufen des Usernames:', error);
    }
    
    // Fallback: "unknown-user" wenn kein Username verfügbar
    return "unknown-user";
  }

  public resetCollection(): void {
    this.collectionId = null;
    sessionStorage.removeItem('app-collection-id');
    this.collectionName = null;
    this.collectionFolderId = null;
    sessionStorage.removeItem('app-collection-name');
    sessionStorage.removeItem('app-collection-folder-id');
  }
}

export default CollectionService;
